import ServicePage from '@/components/ServicePage';

export default function SecurityAuditsPage() {
  return (
    <ServicePage
      slug="security-audits"
      title="Security Audits & Vulnerability Assessment"
      titleAr="تدقيقات الأمان وتقييم الثغرات"
      description="Protect your applications and data with comprehensive security audits. Our Egyptian security team identifies vulnerabilities, implements fixes, and ensures compliance with industry standards."
      descriptionAr="حمي تطبيقاتك وبياناتك بتدقيقات أمان شاملة. يحدد فريق الأمان المصري لدينا الثغرات، وينفذ الإصلاحات، ويضمن الامتثال لمعايير الصناعة."
      keywords="security audit services, vulnerability assessment, penetration testing Egypt, application security, cybersecurity, code security review"
      heroImage="https://readdy.ai/api/search-image?query=Cybersecurity%20and%20digital%20protection%20concept%2C%20shield%20with%20lock%20icon%20in%20digital%20network%20environment%2C%20blue%20glowing%20security%20elements%2C%20modern%20technology%20background%2C%20professional%20corporate%20style%2C%20clean%20minimal%20design%2C%20data%20protection%20visualization&width=1400&height=600&seq=svc6&orientation=landscape"
      icon="ri-shield-check-line"
      features={[
        {
          title: 'Vulnerability Scanning',
          titleAr: 'فحص الثغرات',
          description: 'We use automated scanners and manual testing to identify SQL injection, XSS, CSRF, insecure authentication, and outdated dependencies in your applications.',
          descriptionAr: 'نستخدم الماسحات الضوئية الآلية والاختبار اليدوي لتحديد SQL injection، و XSS، و CSRF، ومصادقة غير آمنة، والتبعيات القديمة في تطبيقاتك.',
        },
        {
          title: 'Code Security Review',
          titleAr: 'مراجعة أمان الكود',
          description: 'Our engineers manually review your codebase for security anti-patterns, hardcoded secrets, improper input validation, and insecure API endpoints.',
          descriptionAr: 'يقوم مهندسونا بمراجعة قاعدة الكود الخاصة بك يدوياً للبحث عن أنماط أمان مضادة، وأسرار مكتوبة بصلابة، وتحقق من الإدخال غير السليم، ونقاط نهاية API غير الآمنة.',
        },
        {
          title: 'Penetration Testing',
          titleAr: 'اختبار الاختراق',
          description: 'Simulated attacks against your application to identify exploitable weaknesses. We test authentication bypass, privilege escalation, data exfiltration, and business logic flaws.',
          descriptionAr: 'هجمات محاكاة ضد تطبيقك لتحديد نقاط الضعف القابلة للاستغلال. نختبر تجاوز المصادقة، وتصعيد الامتيازات، واستخراج البيانات، وعيوب منطق الأعمال.',
        },
        {
          title: 'Security Patching',
          titleAr: 'تصحيحات الأمان',
          description: 'We apply security patches, update dependencies, and configure security headers. OWASP Top 10 compliance is our baseline standard for every audit.',
          descriptionAr: 'نطبق تصحيحات الأمان، ونحدث التبعيات، ونكوّن رؤوس الأمان. الامتثال لـ OWASP Top 10 هو معيارنا الأساسي لكل تدقيق.',
        },
        {
          title: 'Compliance Assessment',
          titleAr: 'تقييم الامتثال',
          description: 'We evaluate your application against GDPR, PCI DSS, HIPAA, and industry-specific standards. Our reports include gap analysis and remediation roadmaps.',
          descriptionAr: 'نقيم تطبيقك مقابل GDPR، و PCI DSS، و HIPAA، ومعايير خاصة بالصناعة. تتضمن تقاريرنا تحليل الفجوات وخرائط طريق الإصلاح.',
        },
        {
          title: 'Security Monitoring Setup',
          titleAr: 'إعداد مراقبة الأمان',
          description: 'We implement intrusion detection, anomaly monitoring, and automated security alerting. Real-time dashboards track login attempts, API abuse, and data access patterns.',
          descriptionAr: 'ننفذ كشف التطفل، ومراقبة الشذوذ، والتنبيه الأمني الآلي. تتبع لوحات المعلومات في الوقت الفعلي محاولات تسجيل الدخول، وإساءة استخدام API، وأنماط الوصول إلى البيانات.',
        },
      ]}
      benefits={[
        {
          title: 'Prevent Data Breaches',
          titleAr: 'منع خروقات البيانات',
          description: 'The average data breach costs $4.45 million. Our security audits identify vulnerabilities before attackers do, preventing breaches and protecting your reputation.',
          descriptionAr: 'تكلف خروقات البيانات المتوسط 4.45 مليون دولار. تحدد تدقيقات الأمان لدينا الثغرات قبل أن يفعلها المهاجمون، مما يمنع الخروقات ويحمي سمعتك.',
        },
        {
          title: 'Regulatory Compliance',
          titleAr: 'الامتثال التنظيمي',
          description: 'Compliance with GDPR, PCI DSS, and local Egyptian data protection laws is mandatory. Our audits ensure you meet requirements and avoid penalties.',
          descriptionAr: 'الامتثال لـ GDPR، و PCI DSS، وقوانين حماية البيانات المصرية المحلية إلزامي. تضمن تدقيقاتنا استيفاءك للمتطلبات وتجنب العقوبات.',
        },
        {
          title: 'Customer Trust',
          titleAr: 'ثقة العملاء',
          description: 'Displaying security certifications and audit results builds customer confidence. Especially important for fintech, healthcare, and e-commerce businesses.',
          descriptionAr: 'يعرض شهادات الأمان ونتائج التدقيق بناء ثقة العملاء. مهم بشكل خاص لأعمال التكنولوجيا المالية، والرعاية الصحية، والتجارة الإلكترونية.',
        },
        {
          title: 'Continuous Security',
          titleAr: 'الأمان المستمر',
          description: 'Security is not a one-time event. We offer quarterly re-audits, continuous monitoring, and incident response retainers to keep your applications secure as threats evolve.',
          descriptionAr: 'الأمان ليس حدثاً لمرة واحدة. نقدم إعادة تدقيق ربع سنوية، ومراقبة مستمرة، واستبقاءات الاستجابة للحوادث للحفاظ على تطبيقاتك آمنة مع تطور التهديدات.',
        },
      ]}
      faqs={[
        {
          question: 'How often should I conduct a security audit?',
          questionAr: 'كم مرة يجب أن أجري تدقيقاً أمنياً؟',
          answer: 'We recommend quarterly audits for production applications, especially if you handle sensitive data. Annual audits are the minimum. After any major release or infrastructure change, an immediate security review is essential.',
          answerAr: 'نوصي بالتدقيقات ربع السنوية للتطبيقات الإنتاجية، خاصة إذا كنت تتعامل مع بيانات حساسة. التدقيقات السنوية هي الحد الأدنى. بعد أي إصدار رئيسي أو تغيير في البنية التحتية، يكون المراجعة الأمنية الفورية ضرورية.',
        },
        {
          question: 'What is included in your security audit report?',
          questionAr: 'ما الذي يتضمنه تقرير تدقيق الأمان الخاص بكم؟',
          answer: 'Our report includes: vulnerability inventory with severity ratings, exploit proof-of-concepts, step-by-step remediation instructions, code review findings, compliance gap analysis, and an executive summary for stakeholders.',
          answerAr: 'يتضمن تقريرنا: جرد الثغرات مع تصنيفات الشدة، وإثباتات المفاهيم القابلة للاستغلال، وتعليمات الإصلاح خطوة بخطوة، ونتائج مراجعة الكود، وتحليل فجوات الامتثال، وملخص تنفيذي للأصحاب المصلحة.',
        },
        {
          question: 'Do you fix the vulnerabilities you find?',
          questionAr: 'هل تقومون بإصلاح الثغرات التي تجدونها؟',
          answer: 'Yes. We offer both audit-only and audit-plus-remediation packages. With remediation, our team fixes all identified vulnerabilities and provides patches, configuration updates, and hardening guidelines.',
          answerAr: 'نعم. نقدم حزم تدقيق فقط وتدقيق مع الإصلاح. مع الإصلاح، يقوم فريقنا بإصلاح جميع الثغرات المحددة ويقدم تصحيحات، وتحديثات التكوين، وإرشادات التصليب.',
        },
      ]}
      relatedServices={[
        { slug: 'bug-fixing', title: 'Bug Fixing & Debugging', titleAr: 'إصلاح الأخطاء والتصحيح', icon: 'ri-bug-line' },
        { slug: 'custom-development', title: 'Custom Development', titleAr: 'التطوير المخصص', icon: 'ri-code-s-slash-line' },
        { slug: 'cloud-services', title: 'Cloud Services', titleAr: 'الخدمات السحابية', icon: 'ri-cloud-line' },
      ]}
    />
  );
}